import { render, staticRenderFns } from "./MonthHomeWork.vue?vue&type=template&id=e84aae4a&scoped=true&"
import script from "./MonthHomeWork.vue?vue&type=script&lang=js&"
export * from "./MonthHomeWork.vue?vue&type=script&lang=js&"
import style0 from "./MonthHomeWork.vue?vue&type=style&index=0&id=e84aae4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84aae4a",
  null
  
)

export default component.exports